import { motion } from "framer-motion"

const STILL = "https://static.lumi.new/5b/5bd0243eeec5727e73fef2f2bfa33b9d.webp"

function Archive() {
  return (
    <section id="archive" className="relative w-full bg-[#0b0b0b]">
      <div className="grid w-full md:grid-cols-2">
        <div className="order-2 flex flex-col items-center justify-center px-8 py-28 text-center md:order-1 md:px-16 md:py-24 lg:px-20">
          <motion.p
            className="font-sans-ui text-[11px] tracking-[0.48em] text-[#c4a574]"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            06
          </motion.p>
          <motion.h2
            className="font-display mt-10 text-4xl text-[#f7f1e6] md:mt-8 md:text-6xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.1 }}
          >
            全球限量 500 組
          </motion.h2>
          <motion.p
            className="font-sans-ui mt-10 text-3xl tracking-[0.18em] text-[#c4a574] md:mt-8 md:text-5xl"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, delay: 0.1 }}
          >
            NT$1,280
          </motion.p>
          <motion.p
            className="font-sans-ui mx-auto mt-8 max-w-xs text-[13px] leading-7 text-stone-400 md:mt-12 md:text-sm md:leading-8"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, delay: 0.2 }}
          >
            每組附限量編號與冠軍作品典藏卡。
          </motion.p>
        </div>

        <div className="relative order-1 min-h-[56vh] overflow-hidden md:order-2 md:min-h-screen">
          <motion.img
            src={STILL}
            alt="冠軍作品典藏"
            className="absolute inset-0 h-full w-full object-cover"
            initial={{ scale: 1.08 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 2.6, ease: [0.22, 1, 0.36, 1] }}
          />
        </div>
      </div>
    </section>
  )
}

export default Archive
